(() => {
  const pad = (value) => String(value).padStart(2, '0');
  const galleries = new Map();
  let layoutFrame = 0;

  function synchronizeConfiguratorDiscountBadges() {
    document.querySelectorAll('.product-block .typelab-collection-config-price__discount').forEach((badge) => {
      const card = badge.closest('.product-block');
      const media = card.querySelector('.product-block__image-container .relative') ||
        card.querySelector('.product-block__image-container');
      if (!media) return;
      let labels = media.querySelector('.kbd-product-label-row');
      if (!labels) {
        labels = document.createElement('div');
        labels.className = 'kbd-product-label-row';
        media.appendChild(labels);
      }
      card.classList.add('kbd-configurator-discount-card');
      if (badge.parentElement !== labels) labels.insertBefore(badge, labels.firstChild);
    });
  }

  function initializeConfiguratorDiscountBadges() {
    synchronizeConfiguratorDiscountBadges();
    new MutationObserver((mutations) => {
      const changed = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) =>
        node.nodeType === 1 && (
          node.matches('.typelab-collection-config-price, .typelab-collection-config-price__discount, .kbd-product-label-row') ||
          node.querySelector('.typelab-collection-config-price, .typelab-collection-config-price__discount, .kbd-product-label-row')
        )
      ));
      if (changed) synchronizeConfiguratorDiscountBadges();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function scheduleGalleryLayout() {
    if (layoutFrame) return;
    layoutFrame = window.requestAnimationFrame(() => {
      layoutFrame = 0;
      synchronizeGalleryLayout();
    });
  }

  function synchronizeGalleryLayout() {
    galleries.forEach((state, container) => {
      if (container.isConnected) return;
      state.resize.disconnect();
      state.mutation.disconnect();
      galleries.delete(container);
    });
    document.querySelectorAll('.product-detail__images-container').forEach((container) => {
      const overlay = container.querySelector('.kbd-product-page-badges');
      if (!overlay) return;
      let state = galleries.get(container);
      if (!state) {
        const resize = new ResizeObserver(scheduleGalleryLayout);
        const mutation = new MutationObserver((records) => {
          if (records.some((record) => record.type === 'attributes' ||
            [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1))) {
            scheduleGalleryLayout();
          }
        });
        state = { resize, mutation, viewport: null };
        galleries.set(container, state);
        resize.observe(container);
        mutation.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
      const viewport = container.querySelector('.product-detail__images .slick-list') ||
        container.querySelector('[data-product-media]');
      if (!viewport) return;
      if (state.viewport !== viewport) {
        if (state.viewport) state.resize.unobserve(state.viewport);
        state.viewport = viewport;
        state.resize.observe(viewport);
      }
      const bounds = viewport.getBoundingClientRect();
      const parentBounds = container.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const currentMedia = viewport.querySelector('.slick-current [data-product-media]');
      const mediaGap = currentMedia ? parseFloat(getComputedStyle(currentMedia).marginBottom) || 0 : 0;
      const properties = {
        '--kbd-media-top': bounds.top - parentBounds.top,
        '--kbd-media-left': bounds.left - parentBounds.left,
        '--kbd-media-width': bounds.width,
        '--kbd-media-height': Math.max(0, bounds.height - mediaGap)
      };
      Object.entries(properties).forEach(([name, value]) => {
        const pixels = `${Math.round(value * 100) / 100}px`;
        if (overlay.style.getPropertyValue(name) !== pixels) overlay.style.setProperty(name, pixels);
      });
    });
  }

  function renderCountdown(element, now = Date.now()) {
    const end = Date.parse(element.dataset.endAt || '');
    const value = element.querySelector('.kbd-product-countdown__value');
    const prefix = element.querySelector('.kbd-product-countdown__prefix');
    if (!value || !prefix || Number.isNaN(end)) {
      element.hidden = true;
      return;
    }

    const remaining = end - now;
    if (remaining <= 0) {
      prefix.textContent = element.dataset.endedText || '团购结束';
      value.hidden = true;
      element.removeAttribute('aria-live');
      return;
    }

    prefix.textContent = element.dataset.prefix || '团购进行中';
    value.hidden = false;
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    value.textContent = `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  function tick() {
    const now = Date.now();
    document.querySelectorAll('[data-kbd-countdown]').forEach((node) => renderCountdown(node, now));
    synchronizeGalleryLayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeConfiguratorDiscountBadges, { once: true });
    document.addEventListener('DOMContentLoaded', tick, { once: true });
  } else {
    initializeConfiguratorDiscountBadges();
    tick();
  }
  window.setInterval(tick, 1000);
  window.addEventListener('resize', scheduleGalleryLayout, { passive: true });
  document.addEventListener('load', scheduleGalleryLayout, true);
  document.addEventListener('shopify:section:load', scheduleGalleryLayout);
})();
